import React from 'react';
import PropTypes from 'prop-types';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';

const CustomDropdownIndicator = props => {
  const { selectProps } = props;
  return selectProps.menuIsOpen ? (<ArrowDropUpIcon />) : (<ArrowDropDownIcon />);
}

CustomDropdownIndicator.propTypes = {
  selectProps: PropTypes.shape({
    menuIsOpen: PropTypes.bool,
  }).isRequired,
}

export default CustomDropdownIndicator;
